// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: 'microsoft',
  googleMaps: {
    apiKey: 'AIzaSyAJ_ex4c4b5i6FjV06hH5k-wkp7knw_huY', 
  },
  internalEndPoint:'https://us-central1-smartbare.cloudfunctions.net',
  // baseUrl: "http://localhost:5002",
  baseUrl: "https://iobox-web-api-iobox-web-api-test.azurewebsites.net",
  // baseUrl: "https://iobox-web-api.azurewebsites.net",
  subscriptionKey: "ceab58b75fa34201a51ef359cc608987"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
